/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import Title from '@/components/AZCustomComponent/Title';
import { useLabel } from '@/hooks/useLabels';
import azCommonStyles from '@/theme/globals.module.scss';
import Head from 'next/head';
import React from 'react';
import type { FaqResponseModel } from '@/api/types/seo-data-types';
import styles from './styles.module.scss';

type Props = {
  faqs: FaqResponseModel[] | null;
};

export const FaqComp = ({ faqs }: Props) => {
  const lblTitle = useLabel('label_questions_and_answers');
  return (
    <div data-testid="category-reviews" className={styles.faqContainer}>
      <Head>
        <script
          type="application/ld+json"
          key="categoryFAQ"
          data-testid="categoryFAQ"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: (faqs ?? []).map((faq) => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: faq.answer,
                },
              })),
            }),
          }}
        />
      </Head>
      <div>
        <Title
          firstText={lblTitle}
          underline
          swapStyle
          variant="md"
          stylesClass={azCommonStyles['az-padding-bottom-4xs']}
        />
        {faqs ? (
          <div className={azCommonStyles['az-margin-top-s']}>
            {faqs.map((faq) => (
              <div key={faq.question}>
                <p
                  className={`${azCommonStyles['az-body-1-heavy']} ${azCommonStyles['az-margin-bottom-5xs']}`}
                >
                  {faq.question}
                </p>
                <p
                  className={`${azCommonStyles['az-body-1-regular']} ${azCommonStyles['az-margin-bottom-s']}`}
                >
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};
